import { Pipe, PipeTransform } from '@angular/core';
import { Formatter, nfCurrencyTransform } from '@aptitude/shared-vanilla';

@Pipe({
    name: 'nfCurrency',
    standalone: false
})
export class NfCurrencyPipe implements PipeTransform {
  transform(amount: number): string {
    return nfCurrencyTransform(amount, Formatter.currency);
  }
}
